import React, { useState } from 'react';

import Image from 'next/image';

import Button from '@components/common/Button/Button';
import useTranslateLpc from '@components/common/hooks/useTranslateLpc';
import useWindowSize from '@components/common/hooks/useWindowSize';
import Text from '@components/common/Text/Text';
import { M_DEVICE } from '@components/lpc/Constants';
import ShareModal from '@components/lpc/ShareModal/ShareModal';

import css from './SharePot.module.scss';

type SharePotProps = {
    isOffered?: boolean;
    personRole?: string;
    potRef?: string;
    potLink?: string;
    namePot?: string;
};

const SharePot = ({ isOffered, personRole, potRef, potLink, namePot }: SharePotProps) => {
    const [shareModalVisible, setShareModalVisible] = useState<boolean>(false);
    const { t } = useTranslateLpc('common');
    const { width } = useWindowSize();

    return (
        <>
            <ShareModal
                isVisible={shareModalVisible}
                onHide={() => {
                    setShareModalVisible(false);
                }}
                potRef={potRef}
                personRole={personRole}
                isOffered={isOffered}
                potLink={potLink}
                namePot={namePot}
            />
            <section className={css.share_pot_container}>
                <Button
                    type={'button'}
                    variant={'primary'}
                    customClass={css.share_pot_container_btn}
                    onClick={() => {
                        if (width < M_DEVICE && navigator.share && navigator.canShare({ url: window.location.href })) {
                            navigator.share({ url: window.location.href });
                        } else {
                            setShareModalVisible(true);
                        }
                    }}
                >
                    <div className={css.share_pot_container__share_label}>
                        <Text tag={'span'} variant={'mini_label'} color={'brand-primary'}>
                            {t('competition-game.share')}
                        </Text>
                        <Image
                            src="/front-static/icons/action/external-link-primary.svg"
                            alt="share-pot"
                            height={24}
                            width={24}
                        />
                    </div>
                </Button>
            </section>
        </>
    );
};

export default SharePot;
